<template>
  <div class="celerity-repairs">
    <div class="celerity-repairs-title">
      <div class="repairs-title-img" />
      <div class="repairs-title-sign">{{ $t('device') }}:</div>
    </div>
    <div>
      <van-field
        v-for="(item,index) of infoList"
        :key="index"
        v-model="userSumbitList[item.content]"
        v-bind="item.bind"
        :label="$t(item.title)"
        :placeholder="item.placeholder"
      >
        <template v-if="index === 0" #right-icon>
          <van-button type="info" size="mini" @click="deviceCodeListShow = true">已有设备</van-button>
        </template>
        <template v-slot:label>
          <split-label :label="$t(item.title)" style="width: 50px;" />
        </template>
      </van-field>
    </div>
    <div class="celerity-repairs-title">
      <div class="describe">
        <div class="celerity-repairs-title">
          <div class="repairs-title-img  describe-margin" />
          <div class="repairs-title-sign">{{ $t('describeLocation') }}:</div>
        </div>
        <div class="update-around">
          <div class="function">
            <div class="function-img" @click="showPopup(1)">
              <img alt="" src="@/assets/images/icon_voice@2x.png">
              <p>{{ $t('voice') }}</p>
            </div>
          </div>
          <div class="function">
            <input id="fileVideo" ref="fileVideo" accept="video/*" multiple="multiple" type="file" style="display: none;" @change="handlePostVideo">
            <div class="function-img" @click="() => $refs['fileVideo'].click()">
              <img alt="" src="@/assets/images/icon_video@2x.png">
              <p>{{ $t('video') }}</p>
            </div>
          </div>
          <div class="function">
            <input id="fileImage" ref="file" multiple="multiple" type="file" style="display: none;" accept="image/*" @change="handlePostImg">
            <div class="function-img" @click="() => $refs['file'].click()">
              <img alt="" src="@/assets/images/icon_photo@2x.png">
              <p>{{ $t('picture') }}</p>
            </div>
          </div>
          <div class="function">
            <div class="function-img" @click="showPopup(2)">
              <img alt="" src="@/assets/images/icon_sdit@2x.png">
              <p>{{ $t('text') }}</p>
            </div>
          </div>
        </div>
        <div class="repairs-around">
          <!--信息展示部分👇-->
          <div class="repairs-around-content">
            <div v-if="imgFileList.length !== 0" class="repairs-around-info">
              <div class="celerity-repairs-title">
                <div class="repairs-title-img  describe-margin" />
                <div class="repairs-title-sign">图片描述:</div>
              </div>
              <div class="imgs-arr">
                <div v-for="(item,index) of imgFileList" :key="index" class="img-class-div">
                  <div class="del-img" @click="handleDelImage(index)">X</div>
                  <img
                    :src="item.path"
                    class="img-class"
                    alt=""
                    @click="preview(index)"
                  >
                </div>
              </div>
            </div>
            <div v-if="videoList.length !== 0" class="repairs-around-info">
              <div class="celerity-repairs-title">
                <div class="repairs-title-img  describe-margin" />
                <div class="repairs-title-sign">视频描述:</div>
              </div>
              <div class="demo1-video">
                <div v-for="(item,index) of videoList" :key="index" class="video-class">
                  <div class="del-img" @click="handleDelVideo(index)">X</div>
                  <video
                    v-if="$store.state.isAndroid === true"
                    :ref="`video_${index}`"
                    :key="index"
                    style="object-fit:fill"
                    x5-video-player-fullscreen="true"
                    class="myVideo"
                    :poster="[$store.state.isAndroid ? '':require('@/assets/video@2x.png')]"
                    @click="playVideo(index)"
                  >    <source :src="item.path" type="video/mp4">
                  </video>
                  <video
                    v-if="$store.state.isAndroid === false"
                    :ref="`video_${index}`"
                    :key="index"
                    controls
                    style="object-fit:fill"
                    x5-video-player-fullscreen="true"
                    class="myVideo"
                    :poster="[$store.state.isAndroid ? '':require('@/assets/video@2x.png')]"
                    @click="playVideo(index)"
                  >    <source :src="item.path" type="video/mp4">
                  </video>
                </div>
              </div>
            </div>

            <div v-if="audioList.length !== 0" class="repairs-around-info">
              <div class="celerity-repairs-title">
                <div class="repairs-title-img  describe-margin" />
                <div class="repairs-title-sign">语音描述:</div>
              </div>
              <div v-for="(item,index) of audioList" :key="index" class="repairs-content-voice-title">
                <div class="flex-start">
                  <div class="content-voice-title">描述{{ index+1 }}：</div>
                  <div
                    class="repairs-title-voice"
                    @click="HandlePlayAudioClick(item.localId,index,item.duration)"
                  >
                    <PlayIcon :id="'audio' + index" name="actAudio" style="" />
                    <img :id="index" name="noAudio" src="@/assets/images/voice-icon.png" class="repairs-title-voice-icon">
                    <div :style="[{width:item.duration > 60? '60': item.duration+'px'}]" />
                    <audio :id="item.localId" :src="item.Content" muted="muted" />
                    <div class="repairs-title-voice-num">{{ item.duration }}"</div>
                  </div>
                </div>
                <div class="content-voice-title content-voice-del" @click="handleDelVoice(index)">删除</div>
              </div>
            </div>
            <div v-if="textUpload" class="repairs-around-info">
              <div v-if="textUpload" class="celerity-repairs-title">
                <div class="repairs-title-img  describe-margin" />
                <div class="repairs-title-sign">文字描述:</div>
              </div>
              <div class="repairs-title-content-text">{{ textUpload }}</div>
            </div>
          <!--信息展示部分👆-->
          </div>
          <div class="uploading">
            <div class="uploading-around" @click="() => $refs['fileUpload'].click()">
              <input id="fileLoad" ref="fileUpload" :multiple="false" accept="*" type="file" style="display: none;" @change="handlePostFile">
              <van-button class="uploading-button" icon="" type="primary">{{ $t('uploadFiles') }}</van-button>
            </div>
            <p class="uploading-sign">支持扩展名：.rar .zip .ppt .docx .pdf .xlsx .txt</p>
          </div>
          <div class="flex-start flex-wrap">
            <div v-for="(item,index) of fileNameList" :key="index" class="file-name-list">
              <div class="del-img" @click="handleDelFlile(index)">X</div>
              <img alt="" src="@/assets/images/file-icon.png" class="file-icon">
              <div class="file-title">{{ item.fileName }}</div>
            </div>
          </div>
        </div>
        <div v-show="isOriginHei" class="describe-button-around">
          <button class="describe-button" @click="signToast">{{ $t('confirmRepair') }}</button>
        </div>
        <AudioHint v-show="audioHint" />
        <van-popup v-model="voiceShow" position="bottom" round>
          <div class="transcribe-around-x" @click="() => {voiceShow = false}">X</div>
          <div class="transcribe-around">
            <div class="dis-fl-clo">
              <div class="transcribe-icon-hint">点击进行复听</div>
              <img alt="" class="transcribe-icon-play" src="@/assets/images/1-1.png" @click="startVoice('play')">
            </div>
            <div class="dis-fl-clo">
              <div class="transcribe-icon-hint">请长按进行录音</div>
              <div class="transcribe-icon-play" style="position: absolute;z-index: 10" @touchend.stop.prevent="startVoice('stop')" @touchstart.stop.prevent="startVoice('start')" />
              <img id="axaxax" alt="" class="transcribe-icon-play" src="@/assets/images/record.jpg">
            </div>
          </div>
        </van-popup>
        <van-popup v-model="textShow" class="van-popup-user-said">
          <div class="user-said">
            <div class="van-popup-title">请输入</div>
            <textarea v-model="textUpload" class="textShow-window" :placeholder="$t('PleaseContent')" />
            <van-button size="small" type="primary" class="submitButton" @click="leaveMessage">确定</van-button>
          </div>
        </van-popup>
        <van-popup v-model="deviceCodeListShow" position="bottom">
          <van-picker
            title="设备列表"
            show-toolbar
            :columns="deviceCodeList"
            @confirm="onConfirm"
            @cancel="onCancel"
          />
        </van-popup>
        <van-overlay :show="loading" class="overlay-loading">
          <van-loading size="40px" />
        </van-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import { getLocalStore, removeLocalStore } from '@/utils'
import { Dialog, ImagePreview, Toast } from 'vant'
// import Recorder from 'js-audio-recorder'
import { infoList } from '@/utils/titleList'
import dayjs from 'dayjs'
import { addData } from '@/utils/postFile'
import AudioHint from '@/components/AudioHint'
import PlayIcon from '@/components/playIcon'
// const recorder = new Recorder()

export default {
  name: 'CelerityRepairs',
  components: { [Dialog.Component.name]: Dialog.Component, AudioHint, PlayIcon },
  data() {
    return {
      audioHint: false, // 语音图标
      deviceCodeListShow: false, // 以后设备列表
      deviceCodeList: [], // 选择设备列表
      audioList: [], // 语音数组
      videoList: [], // 视频数组
      documentHeight: document.documentElement.clientHeight, // 默认屏幕高度
      isOriginHei: true, // 报修按钮 当输入时隐藏该按钮
      loading: false, // loading
      imgFileList: [], // 预览图片用数组
      userSumbitList: {
        deviceCode: '', // 设备码
        hospitalName: '', // 医院名称
        model: ''// 分类
      },
      fileNameList: [], // 文件上传列表
      audioStauts: '', // 语音录制状态
      duration: 0, // 语音时长
      audioIdList: [], // 语音id
      localId: '', // 微信语音id
      userInfo: [], // 个人信息列表
      recordingTime: [], // 录音时长集合
      accessoryInventory: [], // 上传附件
      accessoryList: [], // 附件列表
      // uploadInventory 为{ 'repairContentType': '', 'Content': '' }格式
      uploadInventory: [], // 上传列表
      uploadList: [], // 本地上传列表
      textUpload: '', // 上传文本内容
      voiceShow: false, // 语音窗口
      // 提交的时候
      infoList, // js文件引入的
      textShow: false, // 文本窗口
      wxBrowser: ''// 是否是微信内置游览器
    }
  },
  watch: {
    // 监听设备码自动填入
    'userSumbitList.deviceCode': {
      handler() {
        this.watchDeviceCode()
      }
    },
    deep: true
  },
  mounted() {
    this.handleGetDeviceCode()
    this.handleMountedDcode()
    // window.onresize监听页面高度的变化
    window.onresize = () => {
      return (() => {
        if (this.documentHeight > document.documentElement.clientHeight) {
          this.isOriginHei = false
        } else {
          this.isOriginHei = true
        }
      })()
    }
    this.handleQiNiuToken()
  },
  methods: {
    /* 播放视频*/
    playVideo(index) {
      const video = this.$refs[`video_${index}`][0]
      video.requestFullscreen()
      video.play()
    },
    onConfirm(value) {
      this.userSumbitList.deviceCode = value
      this.deviceCodeListShow = false
    },
    onCancel() {
      this.deviceCodeListShow = false
    },
    /*
    * 获取用户设备列表
    */
    handleGetDeviceCode() {
      this.$api('USER_INFO_H5', {}, true).then((res) => {
        if (res.code !== 200) {
          this.$toast(res.msg)
          return
        }
        removeLocalStore('deviceCode')
        removeLocalStore('redirect')
        if (res.result.userDeviceCodeList.length === 1 && !this.$route.query.deviceCode) {
          this.userSumbitList.deviceCode = res.result.userDeviceCodeList[0].deviceCode
        }
        res.result.userDeviceCodeList.forEach((item) => {
          this.deviceCodeList.push(item.deviceCode)
        })
      })
    },
    /*
    * post上传文件
    */
    handlePostFile() {
      const formData = new FormData()
      const windowURL = window.URL || window.webkitURL
      const inputElement = document.getElementById('fileLoad')
      const file = inputElement.files[0]
      console.log(file)
      const fileType = file.name.split('\.').reverse()[0].toLowerCase()
      const path = windowURL.createObjectURL(file)
      formData.append('file', file)

      if (
        // eslint-disable-next-line eqeqeq
        fileType != 'docx' && fileType != 'rar' && fileType != 'zip' && fileType != 'pdf' && fileType != 'xlsx' && fileType != 'xls' && fileType != 'ppt' && fileType != 'doc' && fileType != 'txt') {
        Toast(fileType + '文件格式不支持')
        return
      }
      this.fileNameList.push({ path, formData, repairContentType: 'FILE', fileName: file.name })
    },
    handleDelFlile(index) {
      Dialog.confirm({
        title: '提示',
        message: '是否删除该文件!'
      })
        .then(() => {
          this.fileNameList.splice(index, 1)
        })
        .catch(() => {
          // on cancel
        })
    },
    handlePostImg(e) {
      const file = []
      const inputElement = document.getElementById('fileImage')
      inputElement.files.forEach((item) => {
        console.log(item.name + '000000000000')
        const name = item.name.split('\.').reverse()[0].toLowerCase()
        console.log('name =========>' + name)
        // eslint-disable-next-line no-constant-condition,eqeqeq
        if (name !== 'jpeg' && name !== 'png' && name !== 'jpg') {
          file.push(item.name)
          return
        }
        const windowURL = window.URL || window.webkitURL
        const formData = new FormData()
        const path = windowURL.createObjectURL(item)
        formData.append('file', item)
        this.imgFileList.push({ path, formData, repairContentType: 'IMAGE' })
      })
      console.log('file================>' + file)
      if (file !== [] && file.length !== 0) {
        file.join(',')
        console.log(file)
        Toast(file + '文件格式不正确')
      }
    },
    handleDelImage(index) {
      Dialog.confirm({
        title: '提示',
        message: '是否删除该图片!'
      })
        .then(() => {
          this.imgFileList.splice(index, 1)
        })
        .catch(() => {
          // on cancel
        })
    },
    handleDelVideo(index) {
      Dialog.confirm({
        title: '提示',
        message: '是否删除该视频!'
      })
        .then(() => {
          this.videoList.splice(index, 1)
        })
        .catch(() => {
          // on cancel
        })
    },
    handlePostVideo() {
      const file = []
      const inputElement = document.getElementById('fileVideo')
      inputElement.files.forEach((item) => {
        const name = item.name.split('\.').reverse()[0].toLowerCase()
        // eslint-disable-next-line no-constant-condition,eqeqeq
        if (name != 'mp4' && name != 'avi' && name != 'wmv' && name != 'mov') {
          file.push(item.name)
          return
        }
        const formData = new FormData()
        const windowURL = window.URL || window.webkitURL
        const path = windowURL.createObjectURL(item)
        formData.append('file', item)
        this.videoList.push({ path, formData, repairContentType: 'VIDEO' })
      })
      console.log(file)
      if (file !== [] && file.length !== 0) {
        file.join(',')
        Toast(file + '文件格式不正确')
      }
    },
    handleMountedDcode() {
      if (typeof getLocalStore('deviceCode') === 'string' && this.$route.query.deviceCode) {
        this.userSumbitList.deviceCode = getLocalStore('deviceCode')
        this.$api('EQUIPMENT_INFO', {
          deviceCode: getLocalStore('deviceCode')
        }).then((res) => {
          this.userSumbitList.hospitalName = res.result.endUserName
          this.userSumbitList.model = res.result.productModeDesc
        })
      }
    },
    /*
      图片点击预览
    */
    preview(index) {
      const imgArr = this.imgFileList.map(item => item.path)
      ImagePreview({
        images: imgArr,
        startPosition: index
      })
    },
    /*
    * 监听用自动补全设备信息
    * */
    watchDeviceCode() {
      if (this.userSumbitList.deviceCode.length > 5) {
        // 根据deviceCode获取修改信息
        this.$api('EQUIPMENT_INFO', {
          deviceCode: this.userSumbitList.deviceCode
        }).then((res) => {
          if (res.result === null) {
            this.userSumbitList.hospitalName = ''
            this.userSumbitList.model = ''
            return
          }
          this.userSumbitList.hospitalName = res.result.endUserName
          this.userSumbitList.model = res.result.productModeDesc
        })
      }
    },
    /*
    获取微信授权
    */
    handleQiNiuToken() {
      if (this.$store.state.isAndroid) {
        this.$api('OTHER_GET_JSSDK', {
          url: window.location.href
        }).then((res) => {
          const timestamp = res.result.timestamp
          const appId = res.result.appId
          const nonceStr = res.result.nonceStr
          const signature = res.result.signature
          // 微信授权
          wx.config({
            debug: false,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: signature, // 必填，签名
            jsApiList: ['startRecord', 'stopVoice', 'playVoice', 'uploadVoice', 'stopRecord'] // 必填，需要使用的JS接口列表
          })
        })
      }
    },
    /*
      微信游览器语音
    */
    playVoice(localId) {
      wx.playVoice({
        localId: localId || this.localId// 需要播放的音频的本地ID，由stopRecord接口获得
      })
    },
    stopVoice(localId) {
      wx.stopVoice({
        localId
      })
    },
    /*
    * 上传语音
    * */
    uploadVoice(localId) {
      wx.uploadVoice({
        localId, // 需要上传的音频的本地ID，由stopRecord接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: res => {
          const { serverId } = res
          this.audioList.push({
            localId,
            serverId,
            repairContentType: 'AUDIO',
            duration: this.duration
          })
          this.duration = 0
        }
      })
    },
    handleDelVoice(index) {
      Dialog.confirm({
        title: '提示',
        message: '是否删除改语音!'
      })
        .then(() => {
          this.audioList.splice(index, 1)
        })
        .catch(() => {
          // on cancel
        })
    },
    /*
      判断是不是在微信内置的游览器中
    */
    is_wx() {
      const en = window.navigator.userAgent.toLowerCase()
      // 匹配en中是否含有MicroMessenger字符串
      // eslint-disable-next-line eqeqeq
      if (en.match(/MicroMessenger/i) == 'micromessenger') {
        // 微信游览器
        this.wxBrowser = true
        return
      }
      // 其他游览器
      this.wxBrowser = false
    },
    /*
      提交报修信息
    */
    signToast() {
      Dialog.confirm({
        title: this.$t('submitRepair'),
        message: this.$t('repairReport')
      })
        .then(() => {
          this.submitInfo()
        })
    },
    /*
      提交报修信息
      这个参数是一个数组，数组里面两个元素，分别是 repairContentType：报修内容类型 Content：报修内容
      报修内容类型有三种，分别是AUDIO：音频，TEXT：文本，VIDEO：视频
     */
    async submitInfo(type) {
      this.loading = true
      const newFileArr = [...this.imgFileList, ...this.videoList, ...this.fileNameList]
      const FileArr = []
      for (let i = 0; i < newFileArr.length; i++) {
        const { formData, repairContentType } = newFileArr[i]
        const Content = await this.handleUpFile(formData)
        FileArr.push({
          repairContentType: repairContentType,
          Content: Content
        })
      }
      try {
        for (let i = 0; this.audioList.length; i++) {
          const { serverId, repairContentType, duration } = this.audioList[i]
          const Content = await this.handleUpVoice(serverId)
          FileArr.push({
            repairContentType: repairContentType,
            Content: Content,
            duration: duration
          })
        }
      } catch (e) {
        console.log(e)
      }
      return new Promise((resolve, reject) => {
        const sumbitList = {
          deviceCode: this.userSumbitList.deviceCode, // 设备码
          endUserName: this.userSumbitList.hospitalName, // 医院名称
          repairContentList: this.uploadInventory.concat(FileArr),
          model: this.userSumbitList.model
        }
        if (!this.userSumbitList.deviceCode || !this.userSumbitList.hospitalName || !this.userSumbitList.model) {
          this.loading = false
          this.$toast.fail('设备信息不能为空')
          return
        }
        if (FileArr.length === 0 && !this.textUpload) {
          this.loading = false
          this.$toast.fail('请填写或上传故障信息')
          return
        }
        const textFile = { repairContentType: 'TEXT', Content: this.textUpload }
        sumbitList.repairContentList.push(textFile)
        const time = dayjs(new Date()).hour()
        this.$api('REPAIR_H5', sumbitList, true).then((res) => {
          this.loading = false
          if (type === 'none') return
          if (res.code === 206) {
            Dialog.alert({
              title: '温馨提示',
              message: res.msg
            })
            reject(res)
            return
          } else if (res.code !== 200) {
            this.$toast.fail(res.msg)
            reject(res)
            return
          }
          if (time > 17 || time < 9) {
            this.loading = false
            Dialog.alert({
              title: '温馨提示',
              message: '您的报修已提交,微信报修受理时段（9:00~17:00,如果需要加急处理,请拨打热线电话<a href="tel:4006905828">400' +
                ' 690 8528</a>,谢谢!'
            }).then(() => {
              this.$router.push('/')
            })
            return
          }
          removeLocalStore('deviceCode')
          this.$toast.success('提交成功')
          this.$router.push('/')
          resolve(res)
        })
      })
    },

    async handleUpVoice(serverId) {
      return new Promise((resolve, reject) => {
        this.$api('UPLOAD_MEDIA_H5', {
          mediaId: serverId
        }).then((res) => {
          resolve(res.result)
        })
      })
    },

    handleUpFile(formData) {
      return new Promise((resolve, reject) => {
        addData(formData).then(result => {
          // 这里进行获取到result之后的操作
          // return result
          resolve(result)
        })
      })
    },
    /*
      播放语音
    */
    HandlePlayAudioClick(localId, index, time) {
      if (this.stopVoice(this.localIdNow)) {
        this.stopVoice(this.localIdNow)
      }
      document.getElementsByName('actAudio').forEach((item) => {
        item.style.display = 'none'
      })
      document.getElementsByName('noAudio').forEach((item) => {
        item.style.display = 'block'
      })
      document.getElementById(index).style.display = 'none'
      document.getElementById('audio' + index).style.display = 'block'
      this.localIdNow = localId
      this.playVoice(this.localIdNow)
      setTimeout(() => {
        document.getElementById(index).style.display = 'block'
        document.getElementById('audio' + index).style.display = 'none'
      }, time * 1000)
    },
    /*
      留言信息
    */
    leaveMessage() {
      if (this.textUpload === '') {
        this.$toast.fail('留言不能为空')
        return
      }
      this.textShow = false
    },
    // /*
    //   上传录音
    // */
    // handleGetVoiceClick() {
    //   const blob = recorder.getWAVBlob()
    //   const file = new window.File([blob], 'abc.mp3')
    //   uploadQn(file).then(res => {
    //     if (res === '') {
    //       // 没上传成功 重新执行这个方法!
    //       this.handleGetVoiceClick()
    //       return
    //     }
    //     const voiceFile = { 'repairContentType': 'AUDIO', 'Content': res }
    //     this.uploadInventory.push(voiceFile)
    //     this.uploadInventory.push(res)
    //   })
    // },
    /*
    * 停止录音
    * */
    stopRecord() {
      wx.stopRecord({
        success: res => {
          this.localId = res.localId
          this.uploadVoice(res.localId)
        }
      })
    },
    /*
      录音功能
    */
    startVoice(key) {
      if (key === 'start') {
        this.duration = 0
        this.audioHint = true
        wx.startRecord()
        this.audioStauts = setInterval(() => {
          this.duration++
        }, 1000)
        return
      }
      if (key === 'stop') {
        this.audioHint = false
        clearInterval(this.audioStauts)
        this.stopRecord()
        return
      }
      this.$toast('播放')
      this.playVoice()
    },
    /*
    * 弹出层
    */
    showPopup(key) {
      if (key === 1) {
        this.voiceShow = true
        return
      }
      this.textShow = true
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  user-select:none;
}
.dis-fl-clo {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.img-class{
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 10px;
}
.img-class-div{
  position: relative;
  width: 100px;
  height: 100px;
  margin-right: 10px;
  margin-bottom: 10px;

}
.van-popup-title{
font-size: 20px;
}
.del-img{
  position:absolute;
  right: 0;
  background: rgba(0,0,0,0.9);
  color: #FAF9FE;
  width:20px;
  height: 20px;
  border-radius: 10px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}
.preview-cover {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 4px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
}
/*气泡框*/
.repairs-title-voice {
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: 20px;
  margin-left: 10px;
  border-radius: 3px;
  background-color: skyblue;
  border-bottom-color: skyblue;
  /*为了给after伪元素自动继承*/
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  padding: 5px 12px 5px 12px;
  box-sizing: border-box;
  position: relative;
  word-break: break-all;
  .repairs-title-voice-icon{
    width: 10px;
    height: 10px;
  }
  .repairs-title-voice-num{
    font-size: 12px;
    color: #FAF9FE;
    font-weight: 400;
  }
}
.myVideo{
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 10px;
}
.video-class{
  position: relative;
  width: 100px;
  height: 100px;
  margin-right: 10px;
  margin-bottom: 10px;
}
/** 通过对小正方形旋转45度解决 **/
.repairs-title-voice::before {
  content: '';
  position: absolute;
  left: -2px;
  width: 10px;
  height: 10px;
  background: inherit;
  /*自动继承父元素的背景*/
  transform: rotate(45deg);
}

.repairs-title-content-text{
  font-size: 12px;
  padding: 20px 10px;
  color: #808C9B;
  max-width: 380px;
  word-wrap: break-word;
  word-break: normal;
}

.repairs-title-content {
  font-size: 12px;
  color: #808C9B;
  margin-left: 24px;
  width: 200px;
  word-wrap: break-word;
  word-break: normal;
}
.repairs-content-title {
  font-size: 14px;
  margin-left: 35.5px;
  font-weight: 500;
}
.overlay-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
::v-deep .van-field__label {
  display: flex;
  align-items: center;
  padding: 0;
  margin-right: 20px;
  font-size: 10px;
  justify-content: space-between;
}

::v-deep .label-split {
  display: flex;
  justify-content: space-between;
  width: 65px;

  span {
    font-size: 15px;
  }
}

::v-deep .van-cell {
  padding: 5px 30px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  border: none;
}

.celerity-repairs {

  .transcribe-around {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 200px;
    padding: 0 10px;
    z-index: 999;
    .transcribe-icon {
      width: 50px;
      height: 50px;
    }

    .transcribe-icon-play {
      width: 90px;
      height: 90px;
    }
    .transcribe-icon-hint {
      font-size: 15px;
    }
  }
  .transcribe-around-x {
    max-width: 100vh;
    display: flex;
    flex-direction: row-reverse;
    padding: 10px 10px 0 0 ;
    font-size: 18px;
  }
  .van-popup-user-said{
    border-radius: 15px;
  }
  .user-said {
    width: 286px;
    height: 260px;
    display: flex;
    background-color: #FAF9FE;
    align-items: center;
    flex-direction: column;
    border-radius: 15px;
    padding: 20px;
    .submitButton {
      background-color: #005BAC;
      height: 32px;
      border: none;
      border-radius: 15px;
      width: 152px;
    }
    .textShow-window {
      margin-top: 20px;
      font-size: 12px;
      height: 112px;
      width: 100%;
      border-radius: 15px;
      padding: 10px;
      border: 1px solid rgba(0,0,0,0.08);
    }
    button {
      width: 150px;
      margin-top: 20px;
    }
  }

  &:nth-child(2) {
    margin-top: 20px;
  }

  .celerity-repairs-title {
    display: flex;
    align-items: center;

    .repairs-title-img {
      background-image: linear-gradient(#005BAC, #1DA6E3);
      width: 6px;
      height: 20px;
      border-radius: 5px;
      margin-left: 15px;
    }

    .repairs-title-sign {
      font-size: 14px;
      font-weight: 700;
      margin-left: 7px;
    }
  }

  .uploading {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 10px;
    .uploading-around {
      display: flex;

      .uploading-button {
        margin-top: 15px;
        width: 90px;
        height: 26.5px;
        border-radius: 5px;
        background-color: #CEE1F7;
        color: #005BAC;
        font-size: 12px;
        border: none;
      }
    }
    .uploading-sign {
      margin-top: 25px;
      margin-left: 14.5px;
      font-size: 11px;
      color: #808C9B;
      font-weight: 300;
      border: none;
    }
    .uploader-list {
      margin-top: 20px;
    }
  }
  .file-name-list {
    position: relative;
    width: 70px;
    font-size: 12px;
    color: #9ea7b2;
    margin-top: 15px;
    margin-right: 15px;
    .file-title{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      word-break: break-all;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 5px;
      text-align: center;
    }
    .file-icon{
      display: block;
      width: 70px;
      height: 70px;
      margin: auto;
    }
  }
  /*深度挖掘 更改组件样式*/
  ::v-deep .dr__maintenance .base-info {
    padding-left: 28px;
  }

  .celerity-repairs-img {
    display: flex;
    justify-content: center;

    img {
      width: 345px;
      height: 288px;
    }
  }

  .describe-button-around {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999;
    width: 100%;
    align-items: center;
    justify-content: center;

    .describe-button {
      width: 100%;
      height: 44px;
      background-color: #005BAC;
      border: none;
      font-size: 15px;
      color: #ffffff;
    }
  }

  .repairs-content-voice-title{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    margin-top: 10px;
    .content-voice-title{
      width: 50px;
    }
    .content-voice-del{
      color: #005BAC;
      text-decoration:underline;
    }
  }
  .describe {
    padding: 15px;
    margin-bottom: 40px;
    .repairs-around {
      background-color: #fff;
      font-weight: 700;
      margin-top: 20px;

      .repairs-around-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .repairs-around-info {
         /* //display: flex;
          //align-items: center;*/
          margin-top: 10px;
          .imgs-arr{
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-flow: wrap;
          }
          .demo1-video {
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-flow: wrap;
          }
        }
        button {
          margin-top: 20px;
          width: 25px;
          height: 25px;
          border-radius: 25px;
          border: none;
          color: #fff;
          font-size: 11px;
          background-color: #005BAC;
        }
        .repairs-content {
          display: flex;
          align-items: center;
          margin-top: 26px;

          .repairs-voice-second {
            font-size: 12px;
            color: #005BAC;
            margin-left: 10.5px;
            font-weight: 500;
          }

          /*气泡框*/
          .repairs-title-voice {
            //width: 101.5px;
            height: 20px;
            margin-left: 24px;
            background-color: skyblue;
            border-bottom-color: skyblue;
            /*为了给after伪元素自动继承*/
            color: #fff;
            font-size: 12px;
            line-height: 18px;
            padding: 5px 12px 5px 12px;
            box-sizing: border-box;
            position: relative;
            word-break: break-all;
          }

          /** 通过对小正方形旋转45度解决 **/
          .repairs-title-voice::before {
            content: '';
            position: absolute;
            left: -2px;
            width: 10px;
            height: 10px;
            background: inherit;
            /*自动继承父元素的背景*/
            transform: rotate(45deg);
          }

          .repairs-content-title {
            font-size: 14px;
            margin-left: 35.5px;
            font-weight: 500;
          }

          .repairs-title-content {
            font-size: 12px;
            color: #808C9B;
            margin-left: 24px;
            width: 200px;
            word-wrap: break-word;
            word-break: normal;
          }

          .repairs-title-img {
            height: 64px;
            margin-left: 25px;
          }
          .repairs-title-content {
            font-size: 12px;
            color: #808C9B;
            margin-left: 24px;
            width: 200px;
            word-wrap: break-word;
            word-break: normal;
          }
          .repairs-content-title {
            font-size: 14px;
            margin-left: 35.5px;
            font-weight: 500;
          }
        }
      }

      .repairs-around-list {
        margin-left: 20px;
      }

      .repairs-around-p {
        font-size: 14px;
      }
    }

    .update-around {
      display: flex;
      justify-content: space-around;

      .function {
        margin-top: 29.5px;
        display: flex;
        justify-content: space-around;

        .function-img {
          display: flex;
          flex-direction: column;
          align-items: center;

          img {
            width: 30px;
            height: 30px;
          }

          p {
            font-size: 12px;
            margin-top: 13px;
            color: #005BAC;
          }
        }
      }
    }

    .describe-margin {
      margin-left: 0;
    }

    .describe-sign {
      font-size: 12px;
      color: #808C9B;
    }

    .describe-title {
      font-size: 14px;
      font-weight: 700;
    }
  }
}
</style>
